import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const FAQS = [
  {
    question: 'Do I need to know how to code?',
    answer:
      'Not at all. Hackathons need designers, writers, product thinkers, storytellers, and community builders just as much as coders. Morning workshops on Day One get everyone up to speed, and mentors are around all weekend.',
  },
  {
    question: 'Do I need to know about Bitcoin or Nostr already?',
    answer:
      'Nope — total beginners are genuinely welcome. We start from the very basics: what sats are, how a wallet works, and what Nostr is. If you already live on the mempool, there are advanced mentors to push you further.',
  },
  {
    question: 'Who can attend?',
    answer:
      'SheSats is a women-centered space: all women and non-binary people are welcome, of every age, background, and skill level. Allies can support us as mentors, volunteers, or sponsors.',
  },
  {
    question: 'How much does it cost?',
    answer:
      'Nothing. Registration is free, and so are meals, snacks, coffee, and swag — all covered by our sponsors. You just need to get yourself to the venue.',
  },
  {
    question: 'What should I bring?',
    answer:
      'A laptop and charger, a reusable water bottle, and your curiosity. If you don\u2019t have a laptop, tell us when you register — we\u2019ll do our best to pair you up or sort a loaner.',
  },
  {
    question: 'Where exactly is it happening?',
    answer:
      'In Nairobi CBD, within easy reach of matatu and ride-hailing routes. The exact venue is shared with registered attendees ahead of the weekend.',
  },
  {
    question: 'Can I come with a team already formed?',
    answer:
      'Yes! Teams of 2–4 are welcome to arrive ready-made. Flying solo is just as good — team formation happens over lunch on Day One and it\u2019s half the fun.',
  },
];

export function Faq() {
  return (
    <section id="faq" className="scroll-mt-20 py-20 sm:py-28">
      <div className="container grid gap-12 lg:grid-cols-[1fr_1.5fr] lg:gap-16">
        <div className="space-y-4">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-primary">
            Good Questions
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-balance sm:text-5xl">
            Everything you’re wondering
          </h2>
          <p className="text-lg leading-relaxed text-muted-foreground">
            Can’t find your answer? Ask us on Nostr — we hang out on the{' '}
            <a
              href="https://primal.net/search/%23SheSatsNairobi"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-primary underline-offset-4 hover:underline"
            >
              #SheSatsNairobi
            </a>{' '}
            hashtag.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((faq, index) => (
            <AccordionItem key={faq.question} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-base font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
